import { render, staticRenderFns } from "./multifunctional.vue?vue&type=template&id=5974ec91&scoped=true&"
import script from "./multifunctional.vue?vue&type=script&lang=js&"
export * from "./multifunctional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5974ec91",
  null
  
)

export default component.exports